const SystemActions = {
  APP_READY: 'APP_READY'
};

export {
  SystemActions
};
